import { colors, shadows } from "../../../../style/common/partnerStyle";

export const SAMPLE_MATCH_JSON = {
  team_one: {},
  team_two: {},
  team1_scores: [],
  team2_scores: [],
  match_events: [],
  is_completed: false,
  court: {},
  buddy: [],
  leaugue_round: 0,
  session_start: null,
  fixture_sessison: null,
  have_changes: true,
};

export const scheculeModal = {
  content: {
    width: "90%",
    top: "35%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    zIndex: "99",
    padding: "3%",
    minHeight: "42%",
    position: "absolute",
    backgroundColor: "white",
    scrollbarWidth: "0px",
    borderRadius: "3%",
    maxHeight: "80%",
    overflowY: "scroll",
    inset: "15% auto auto 5%",
    boxShadow:
      "rgb(0 0 0 / 16%) 0px 2px 5px 0px, rgb(0 0 0 / 12%) 0px 2px 10px 0px",
  },
};

export const iconBtn = (color) => ({
  background: "none",
  border: "none",
  cursor: "pointer",
  color,
  padding: 0,
  lineHeight: 0,
  display: "inline-flex",
  alignItems: "center",
});

export const S = {
  overlay: {
    position: "fixed",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    background: "rgba(17,24,39,0.45)",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    zIndex: 1000,
  },
  modal: {
    background: colors.surface,
    borderRadius: 12,
    boxShadow: shadows.modal,
    width: "90%",
    maxWidth: 720,
    maxHeight: "90vh",
    display: "flex",
    flexDirection: "column",
    overflow: "hidden",
  },
  body: {
    padding: "20px 24px",
    overflowY: "auto",
    flex: 1,
  },
  closeBtn: {
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    width: 32,
    height: 32,
    border: "none",
    borderRadius: 8,
    background: "#f3f4f6",
    cursor: "pointer",
    color: colors.muted,
    padding: 0,
  },
  groupWrap: {
    marginBottom: 24,
  },
  groupLabel: {
    fontSize: 13,
    fontWeight: 700,
    color: colors.brand,
    textTransform: "uppercase",
    letterSpacing: "0.06em",
    marginBottom: 10,
    paddingBottom: 6,
    borderBottom: `2px solid ${colors.brand}`,
    display: "inline-block",
  },
  tdCenter: {
    padding: "10px 12px",
    color: colors.text,
    borderBottom: `1px solid ${colors.border}`,
    textAlign: "center",
    fontSize: 13,
    whiteSpace: "nowrap",
  },
  tdPoints: {
    padding: "10px 12px",
    borderBottom: `1px solid ${colors.border}`,
    textAlign: "center",
    fontWeight: 700,
    color: colors.brand,
    fontSize: 13,
    whiteSpace: "nowrap",
  },
  zoneRow: {
    display: "flex",
    alignItems: "center",
    gap: 12,
    marginTop: 16,
    paddingTop: 16,
    borderTop: `1px solid ${colors.border}`,
  },
  zoneLabel: {
    fontSize: 13,
    fontWeight: 600,
    color: colors.muted,
    whiteSpace: "nowrap",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    padding: "14px 24px",
    borderTop: `1px solid ${colors.border}`,
  },
};


// WEBPACK FOOTER //
// ./src/app/views/partner/crud/viewFixtureScreen/constants.js